import request from '@/utils/request'
import { getRequest } from "@/utils/postData";
// 列表

export function getFindPrice(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/activityPay/findPrice',
        method: 'get',
        params,
        headers: {
            'X-Signature': sign
        }
    })
}

export function getVipActivityProdList(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/orders/get_products',
        method: 'get',
        params,
        headers: {
        'X-Signature': sign
        }
    })
}

// 快速登录，获取验证码
export function getVerificationCode(data) {
    var sign = getRequest(data);
    return request({
        url: '/v5/yicai_users/new_users_sms',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}

// 登录
export function login(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/activityUsers/sign_in',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}

// 支付
export function payMent(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/activityPay/createOrder',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}




export function findUser(phone) {
    var sign = getRequest({});
    return request({
      url: `/v4/activityPay/findUser?phone=${phone}`,
      method: 'get',
      headers: {
        'X-Signature': sign
      }
    })
  }


  export function getActivityH5(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/activityPay/getPayPage',
        method: 'get',
        params,
        headers: {
        'X-Signature': sign
        }
    })
}

export function getActivityList(params) {
    var sign = getRequest(params);
    return request({
        // url: '/v4/purchase/activity/ladder/list',
        url: '/vtest/purchase/activity/ladder/list',
        method: 'get',
        params,
        headers: {
        'X-Signature': sign
        }
    })
}

export function payMentBatch(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/purchase/activity/pay/createOrder',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/user.js